/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:49acd2fb-33c0-48e8-9529-ad570924cff8",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_wOQNe11NE",
    "aws_user_pools_web_client_id": "5lihhgs9p56oc5q083l4u92bgn",
    "oauth": {}
};


export default awsmobile;
